export default __webpack_public_path__ + "static/media/443.1d37061a.png";